import { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

// import { getHostFromEnv } from './utlis/environment';

const getHostFromEnv = (urlName: string): string => {
  const key = `${urlName}`;
  const host = (window as any)[key] || process.env[key];

  if (host != null) {
    return host;
  }

  throw new Error(`Missing environment configuration with key '${key}'`);
};

const oidcConfig: AuthProviderProps = {
  authority: getHostFromEnv('REACT_APP_ONELOGIN_AUTHORITY'),
  client_id: getHostFromEnv('REACT_APP_ONELOGIN_CLIENT_ID'),
  redirect_uri: getHostFromEnv('REACT_APP_ONELOGIN_REDIRECT_URI'),
  silent_redirect_uri: getHostFromEnv('REACT_APP_ONELOGIN_SILENT_REDIRECT_URI'),
  post_logout_redirect_uri: getHostFromEnv(
    'REACT_APP_ONELOGIN_POST_LOGOUT_REDIRECT_URI'
  ),
  // Vi fornyer selv via addAccessTokenExpiring i UserProvider. SilentRenewService
  // kaller signinSilent() uten argumenter, og da faller `resource` bort i
  // refresh_token-grantet (oidc-client-ts defaulter kun `resource` i
  // authorization-code-flyten). Resultatet er access tokens med feil `aud`,
  // som API-et svarer 401 på mens UI-et fortsatt ser innlogget ut.
  automaticSilentRenew: false,
  response_type: 'code',
  scope: 'openid profile groups email params',
  resource: getHostFromEnv('REACT_APP_ONELOGIN_RESOURCE').split(','),
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export default oidcConfig;
